<template>
    <div class="dropdown filter_item">
        <button
            class="btn m-r-5 waves-effect waves-light dropdown-toggle"
            :class="{'btn-success': ad_type_touched, 'btn-default': !ad_type_touched}"
            type="button" data-toggle="dropdown">
            Tipo de Quarto
        </button>

        <div class="dropdown-menu dropdown-menu-left arrow-dropdown-menu arrow-menu-left dropdown-lg">
            <p class="h5 m-b-15">Tipos de Quarto</p>
            <div class="form-group">
                <div class="checkbox checkbox-success" v-for="(at, index) in ad_types" v-bind:key="index">
                    <input type="checkbox" name="ad_type" :id="'ad_type' + at.id" v-model="model" :value="at.id"/>
                    <label :for="'ad_type' + at.id">{{ at.name }}</label>
                </div>
            </div>
            <div class="row m-t-30">
                <div class="col-xs-12">
                    <button @click="filter()" class="btn btn-block btn-success">Filtrar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            model: this.$store.getters.getFilter.ad_type || [],
        }
    },
    watch: {
        selected_ad_types: {
            handler(newVal) {
                this.model = newVal;
            },
        }
    },
    computed: {
        ad_types() {
            return this.$store.getters.getAdTypes;
        },
        ad_type_touched: function () {
            return this.selected_ad_types.length > 0;
        },
        selected_ad_types: function () {
            return this.$store.getters.getFilter.ad_type || [];
        },
    },
    methods: {
        filter() {
            this.$store.commit('setFilter', { ad_type: this.model });
            this.$emit('filter');
            $(this.$el).find('.dropdown-toggle').dropdown('toggle');
        }
    }
}
</script>